import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GraphConfigurationReferenceLine, GraphConfigurationYAxis, LineGraphType } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-reference-line-graph',
    templateUrl: './modal-reference-line-graph.component.html',
    styleUrls: ['./modal-reference-line-graph.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalReferenceLineGraphComponent implements OnInit {

// FORM
get f() {
  return this.detailForm.controls;
}

yAxis: Array<GraphConfigurationYAxis> = [];


LineTypes = Object.values(LineGraphType);

detailForm: any;

constructor(private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ModalReferenceLineGraphComponent>) {
  this.yAxis = this.data.yAxis;
  this.detailForm = this.fb.group({
    name: ['', Validators.required],
    color: [''],
    width: [1],
    type: [LineGraphType.SOLID],
    yAxisIndex: ['', Validators.required],
    value: ['',Validators.required],
  });
 }

ngOnInit(): void {
}


onSubmit() {
  if(this.detailForm.valid) {
    const referenceLine: GraphConfigurationReferenceLine= {
      name: this.f.name.value ? this.f.name.value : null,
      color: this.f.color.value ? this.f.color.value : '#000000',
      width: this.f.width.value,
      type: this.f.type.value,
      yAxis: this.f.yAxisIndex.value,
      value: this.f.value.value,
    }

    const result = {
      referenceLine: referenceLine,
    }

    this.dialogRef.close(result);

  }
}

}
